var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "columns is-multiline" }, [
      _c("div", { staticClass: "column is-narrow" }, [
        _c("div", { staticClass: "card my-overflow" }, [
          _c("header", { staticClass: "card-header" }, [
            _c("p", { staticClass: "card-header-title has-text-grey" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("customer.shipping.months_review")) + " "
              ),
            ]),
          ]),
          _c("div", { staticClass: "card-content" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "b-field",
                  {
                    attrs: {
                      label: _vm.$t("customer.shipping.see_data_from_before"),
                    },
                  },
                  [
                    _c("b-datepicker", {
                      attrs: {
                        loading: _vm.isFetching,
                        type: "month",
                        placeholder: "Click to select...",
                        icon: "calendar-alt",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.fetchShippings(_vm.selectedMonth)
                        },
                      },
                      model: {
                        value: _vm.selectedMonth,
                        callback: function ($$v) {
                          _vm.selectedMonth = $$v
                        },
                        expression: "selectedMonth",
                      },
                    }),
                  ],
                  1
                ),
                _c("dl", [
                  _c(
                    "dt",
                    [
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("customer.shipping.number_of_shipped_crates")
                          ) + " :"
                        ),
                      ],
                      _c("strong", [_vm._v(_vm._s(_vm.total))]),
                    ],
                    2
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c("gridManager", {
            attrs: { "grid-id": _vm.gridId, profiles: _vm.gridProfiles },
            on: {
              save: _vm.saveProfile,
              create: _vm.createProfile,
              update: _vm.updateProfile,
              select: _vm.selectProfile,
              delete: _vm.deleteProfile,
            },
          }),
          _c("ag-grid-vue", {
            staticClass: "ag-theme-alpine",
            staticStyle: { width: "100%", height: "700px" },
            attrs: {
              id: _vm.gridId,
              "grid-options": _vm.gridOptions,
              pagination: true,
              "pagination-auto-page-size": true,
              "side-bar": ["columns"],
              "row-selection": "multiple",
              "row-data": _vm.filteredEndusers,
              "multi-sort-key": "ctrl",
              "enable-cell-change-flash": true,
              modules: _vm.modules,
            },
            on: { "grid-ready": _vm.onGridReady },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }